import axios from '../axios'
import URL from '@/_url_'
import qs from 'qs'

let lang = localStorage.lang;

export default {
    state: {
        balance: 0, // 余额
        call_user: [], // 支援中心用户列表
        call_list: [], // 支援中心列表
    },
    mutations: {
        setBalance(state, arg){ // 余额写入
            state.balance = arg;
        },
        setCallcenterList(state, arg){ // 支援中心列表写入
            state.call_list = arg;
        },
        setCalluserList(state, arg){ // 支援中心人员写入
            state.call_user = arg;
        }
    },
    actions: {
        getBranchBalance({ commit }, arg){ // 获取分行/子公司余额
            let url = "/index/branch/amount?branch_id=" + arg;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setBalance", res.data.balance);
                }
            }).catch(() => {})
        },
        getDepartmentBalance({ commit }, arg){ // 获取部门余额
            let { branch_id, department_id } = arg,
            url = "/index/member/amount?branch_id="+branch_id+"&department_id="+department_id;
            axios(url).then((res) => {
                if(res.data.code == 1){
                    commit("setBalance", res.data.balance);
                }
            }).catch(() => {})
        },
        getCallcenterList({ rootState, commit }){ // 获取支援中心列表
            commit("handleLoading", true);
            let user_id = rootState.user.user_info.id,
            url = "/index/resource/recording?user_id=" + user_id;
            axios.get(url).then((res) => {
                commit("handleLoading", false);
                if(res.data.code == 1){
                    commit("setCallcenterList", res.data.transaction)
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取支援中心列表接口异常：${err}，请联系管理员`);
            })
        },
        getCalluserList({ commit }, arg){ // 获取支援中心用户列表
            let url = "/index/resource/resource?company_id=" + arg;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setCalluserList", res.data.user)
                }
            }).catch(() => {})
        },
        handleCallApproval({ commit }, arg){ // 提交审批
            commit("handleLoading", true);
            let { type, id, true_amount, member_remark } = arg,
            url = "/index/resource/choose",
            data = qs.stringify({
                type,
                id,
                true_amount,
                member_remark
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        resolve({
                            type: true
                        })
                    }else if(res.data.code == 2){
                        resolve({
                            type: false
                        })
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`提交审批接口异常：${err}，请联系管理员`);
                })
            })
        },
        handleSubmitApply({ rootState, commit }, arg){ // 提交金额申请
            // commit("handleLoading", true);
            let { user_id, amount, member_remark } = arg,
            member_id = rootState.user.user_info.id,
            url = "/index/resource/application",
            data = qs.stringify({
                user_id,
                member_id,
                amount,
                member_remark
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        resolve({
                            type: true
                        })
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`提交金额申请接口异常：${err}，请联系管理员`);
                })
            })
        },
    }
}